import { createSelector } from 'reselect'

export const getConfigurationRoot = createSelector(
  [
    state => state.configuration.rootNode,
  ],
  rootNode => rootNode,
)

export const getConfiguration = createSelector(
  [
    state => state.configuration,
  ],
  configuration => configuration,
)



// WEBPACK FOOTER //
// ./src/modules/configuration/selectors.js